import { inject, Injectable } from '@angular/core';
import { DriverGateway } from './driver.gateway';
import { DriversApiService } from '../../drivers/services/drivers-api.service';
import { LimitsApiService } from '../../limits/services/limits-api.service';
import { WorkingHoursApiService } from '../../working-hours/api/working-hours-api.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class PageDriverGateway implements DriverGateway {

  private limits = inject(LimitsApiService);
  private users = inject(DriversApiService);
  private wh = inject(WorkingHoursApiService);

  getDriverById(id: number) {
    return this.users.getDriverById(id)
      .pipe(map(r => r.data));
  }

  getLimitById(id: string | any)   {
    return this.limits.getLimitById(id);
  }

  getWorkingHoursByDriver(id: number) {
    return this.wh.getWorkingHours([id]);
  }

  blockUnblock(id: number)   {
    return this.users.blockUnblock(id);
  }
}
